import { mergeMessages, type Locale } from "@shared/i18n"

type MessageTree = Record<string, unknown>

export async function loadMessages(locale: Locale): Promise<MessageTree> {
  const english = (await import("../../messages/en.json")).default as MessageTree

  if (locale === "en") {
    return english
  }

  try {
    const localized = (await import(`../../messages/${locale}.json`))
      .default as MessageTree
    return mergeMessages(english, localized)
  } catch {
    return english
  }
}
